import Masonry from 'masonry-layout'
import { initLazyImages } from './lazyImages'

export function initMasonry(): void {
  const container = document.querySelector('.masonry-container') as HTMLElement | null
  if (!container) return

  new Masonry(container, {
    columnWidth: '.masonry-card',
    itemSelector: '.masonry-card',
    gutter: 24,
    transitionDuration: 0,
  })

  container.style.opacity = '1'

  initLazyImages(container)
}
